/**
 * Route for `real-time-roi-measurement-per-creator`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeRoiMeasurementPerCreatorPage } from "../features/real-time-roi-measurement-per-creator/RealTimeRoiMeasurementPerCreatorPage";

export const realTimeRoiMeasurementPerCreatorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-roi-measurement-per-creator",
	component: RealTimeRoiMeasurementPerCreatorPage,
});

export default realTimeRoiMeasurementPerCreatorRoute;
